import { ApiStatus, BladeBaseProps } from '../../types';

export const loanPurposeDefaultAEM = {
    heading: '{heading placeholder}',
    description: '{description placeholder}',
    selectionLabel: '{selectionLabel placeholder}',
    selectText: '{selectText placeholder}',
    confirmButtonText: '{confirmButton placeholder}',
    infoHeader: '{infoHeader placeholder}',
    infoDescription: '{infoDescription placeholder}',
    validations: {
        errorMessage: '{errorMessage placeholder}',
    },
};

export const loanPurposeDefault = {
    loanPurposes: [
        {
            id: 0,
            description: 'A new or second-hand car from a dealer, or private seller, or electric/hybrid cars',
            name: 'policyselection',
            pictogram: 'Accessibility40',
            pictogramTheme: 'beacon',
            title: 'Car',
            value: 'card-0001',
        },
        {
            id: 1,
            description: 'A new or second-hand car from a dealer, or private seller, or electric/hybrid cars',
            name: 'policyselection',
            pictogram: 'Accessibility40',
            pictogramTheme: 'beacon',
            title: 'Personal purchase',
            value: 'card-0001',
        },
        {
            id: 2,
            description: 'A new or second-hand car from a dealer, or private seller, or electric/hybrid cars',
            name: 'policyselection',
            pictogram: 'Accessibility40',
            pictogramTheme: 'beacon',
            title: 'Green purchase',
            value: 'card-0001',
        },
        {
            id: 3,
            description: 'A new or second-hand car from a dealer, or private seller, or electric/hybrid cars',
            name: 'policyselection',
            pictogram: 'Accessibility40',
            pictogramTheme: 'beacon',
            title: 'Refinance',
            value: 'card-0001',
        },
        {
            id: 4,
            description: 'A new or second-hand car from a dealer, or private seller, or electric/hybrid cars',
            name: 'policyselection',
            pictogram: 'Accessibility40',
            pictogramTheme: 'beacon',
            title: 'Didn\'t find it?',
            value: 'card-0001',
        },
    ],
};

export const defaultLoanPurposePictogramMap = [
    {
        loanPurposeId: -1,
        name: 'Car',
        pictogram: 'StandardVehicle64',
    },
    {
        loanPurposeId: -2,
        name: 'Home Improvement',
        pictogram: 'HomeBuying64',
    },
    {
        loanPurposeId: -3,
        name: 'Debt consolidation',
        pictogram: 'DebtConsolidation64',
    },
    {
        loanPurposeId: -4,
        name: 'Green purchase',
        pictogram: 'FinancialPlanning64',
    },
    {
        loanPurposeId: 49,
        name: 'Personal expenses',
        pictogram: 'Celebration64',
    },
    {
        loanPurposeId: 55,
        name: 'Travel',
        pictogram: 'Travel64',
    },
    {
        loanPurposeId: 54,
        name: 'Education',
        pictogram: 'Education64',
    },
    {
        loanPurposeId: 58,
        name: 'Didn\'t find it?',
        pictogram: 'Help64',
    },
];

export type LoanPurposeCard = {
    id: number,
    description: string,
    name: string,
    pictogram?: string,
    pictogramTheme: string,
    title: string,
    value: string,
}

export type loanPurposeAEM = typeof loanPurposeDefaultAEM;
export type loanPurposeData = typeof loanPurposeDefault;

export interface LoanPurposeBladeProps extends BladeBaseProps {
    isMultipleSelect?: boolean;
    isHiddenSelectField?: boolean;
    columnsGrid?: number;
    selectText?: string;
}

export interface LoanPurposeApiEndpoints {
    updateLoanPurposeApiUrl?: string,
    getLoanPurposeApiUrl: string,
}
export interface LoanPurposeRequest {
    applicationNumber: string,
}

export interface LoanPurposeResponse {
    content: loanPurposeAEM,
    loanPurposeData: loanPurposeData,
}

export interface UpdateLoanPurposeRequest extends LoanPurposeRequest {
    selectedLoanPurposeIds: number[],
}

export interface LoanPurposeState {
    content: loanPurposeAEM,
    loanPurposeData: loanPurposeData,
    selectedLoanPurposeIds: number[],
    updateLoanPurposeRequest: UpdateLoanPurposeRequest,
    getLoanPurposeApiStatus: ApiStatus,
    updateLoanPurposeApiStatus: ApiStatus,
    apiEndpoints: LoanPurposeApiEndpoints,
}
